import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import KiloNewtonMillimetre from "../../../../../../components/Math/Units/Metric/KiloNewtonMillimetre";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function BiegemomentDesPfahls({
  bemessungslast,
  knicklastDesGebettetenPfahls,
  biegemomentdesPfahls,
}) {
  const { t } = useTranslation("translation");
  const M_fd_Formula = `\\displaystyle M_{ _{Fd}} = N_{\\tiny _{Fd}} \\cdot e_{\\tiny _0} \\cdot \\left[ \\frac{\\overline{N}_{ki}}{N_{ki} - N_{\\tiny _{Fd}}} \\right]`;

  let value =
    bemessungslast > knicklastDesGebettetenPfahls
      ? "XXX"
      : ConvertToString(biegemomentdesPfahls, 0, "XXX");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.bendingmoment")}</p>}
      indicesValue={
        <span>
          M<sub>Fd</sub>
        </span>
      }
      formulaValue={<ToolTip id={"M_fd_Formula"} type={IconType.FORMULA} formula={M_fd_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={value} />
        </span>
      }
      unitValue={<KiloNewtonMillimetre />}
    />
  );
}

export default BiegemomentDesPfahls;
